import React, { useState } from 'react';
import { FiPlus } from 'react-icons/fi';

function InterestsSettings({
  userData,
  setUserData,
  newInterest,
  setNewInterest,
}) {
  const [showModal, setShowModal] = useState(false);

  const addInterest = () => {
    const trimmed = newInterest.trim();
    if (trimmed && !userData.interests.includes(trimmed)) {
      setUserData({
        ...userData,
        interests: [...userData.interests, trimmed],
      });
    }
    setNewInterest('');
    setShowModal(false);
  };

  const removeInterest = (indexToRemove) => {
    const updated = userData.interests.filter((_, index) => index !== indexToRemove);
    setUserData({ ...userData, interests: updated });
  };

  const renderLabel = (text) => (
    <label className="form-label">
      {text}
      <span className="text-danger"> *</span>
    </label>
  );

  return (
    <>
      <h5 className="mb-3">Profile Settings</h5>

      <div className="mb-3">
        {renderLabel('Year of birth')}
        <input
          type="number"
          className="form-control"
          value={userData.yearOfBirth}
          onChange={(e) => setUserData({ ...userData, yearOfBirth: e.target.value })}
          required
        />
      </div>

      <div className="mb-3">
        {renderLabel('Displayed Name')}
        <input
          className="form-control"
          value={userData.displayName}
          onChange={(e) => setUserData({ ...userData, displayName: e.target.value })}
          required
        />
      </div>

      <div className="mb-3">
        {renderLabel('Gender')}
        <div className="d-flex gap-4">
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="gender"
              id="genderMale"
              value="male"
              checked={userData.gender === 'male'}
              onChange={(e) => setUserData({ ...userData, gender: e.target.value })}
              required
            />
            <label className="form-check-label" htmlFor="genderMale">
              Male
            </label>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="gender"
              id="genderFemale"
              value="female"
              checked={userData.gender === 'female'}
              onChange={(e) => setUserData({ ...userData, gender: e.target.value })}
              required
            />
            <label className="form-check-label" htmlFor="genderFemale">
              Female
            </label>
          </div>
        </div>
      </div>

      <div className="mb-3">
        {renderLabel('Interests')}
        <div className="d-flex flex-wrap gap-2">
          {userData.interests.map((interest, index) => (
            <span
              key={index}
              className="badge d-flex align-items-center border border-info text-info bg-white px-3 py-2"
              style={{ fontSize: '0.9rem' }}
            >
              {interest}
              <button
                type="button"
                className="btn-close btn-close-sm ms-2"
                aria-label="Remove"
                onClick={() => removeInterest(index)}
              ></button>
            </span>
          ))}
          <button
            className="d-flex align-items-center border border-info text-info bg-white rounded px-3 py-2"
            style={{ fontSize: '0.9rem' }}
            onClick={() => setShowModal(true)}
            title="Add Interest"
          >
            <FiPlus size={16} className="me-1" />
            Add
          </button>
        </div>
      </div>

      {showModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Interest</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <input
                  type="text"
                  placeholder="Enter new interest"
                  value={newInterest}
                  onChange={(e) => setNewInterest(e.target.value)}
                  className="form-control"
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  Cancel
                </button>
                <button className="btn btn-primary" onClick={addInterest}>
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default InterestsSettings;